import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import * as PropTypes from "prop-types";
import { Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { ENGINE_CHART_LIST } from "./engine/engineList";
import { clickPanel } from "./engine/engineSelector.js";
import { useVesselSettings } from "../../helpers/vesselSetting/useVesselSettings";

const buttonDesign = {
  alignItems: "left",
  justifyContent: "flex-start",
  display: "flex",
  width: "fitContent",
  "&:focus": {
    outline: "none",
  },
};

const buttonTextDesign = {
  color: "#ffffff",
  fontFamily: "Inter",
  fontSize: "11px",
  fontWeight: "300",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "normal",
  textTransform: "none",
  opacity: "100%",
  justifyContent: "flex-start",
};

const styles = {
  trueButton: {
    ...buttonDesign,
    "& span": {
      ...buttonTextDesign,
      color: "#19b2ab",
      fontWeight: "600",
    },
    borderRadius: 0,
    marginRight: "12px",
    minWidth: "0px",
    pointerEvents: "none",
  },
  falseButton: {
    ...buttonDesign,
    "& span": {
      ...buttonTextDesign,
      color: "#ffffff",
      "&:hover": {
        opacity: "70%",
      },
    },
    marginRight: "12px",
    minWidth: "0px",
    pointerEvents: "auto",
  },
};

export const GraphSelector = React.memo(
  ({
    chartSettingList = ENGINE_CHART_LIST,
    chartType,
    vesselId,
    selectedChart = null,
    setSelectedChart,
  }) => {
    const { t } = useTranslation();
    const { vesselSettings } = useVesselSettings({ vesselId });

    useEffect(() => {
      if(!chartSettingList.some((chartSetting) => chartSetting.id === selectedChart)){
        setSelectedChart(chartSettingList[0].id)
      }
    }, [chartSettingList])

    const displayChartList = () =>
      Object.entries(chartType).map(([k, v], i) => (
        <Button
          onClick={() => clickPanel(v, vesselSettings?.MEEngineType, setSelectedChart)}
          component="button"
          sx={v === selectedChart ? styles.trueButton : styles.falseButton}
          key={`displayChartList-${i}`}
        >
          <span>{t(chartSettingList.find((d) => d.id === v)?.title ?? v)}</span>
        </Button>
      ));

    return (
      <Grid
        container
        justifyContent="flex-start"
        direction="row"
        alignItems="center"
      >
        {displayChartList()}
      </Grid>
    );
  }
);

GraphSelector.propTypes = {
  chartSettingList: PropTypes.array,
  chartType: PropTypes.string,
  selectedChart: PropTypes.string.isRequired,
  setSelectedChart: PropTypes.func.isRequired,
  vesselId: PropTypes.string,
};